import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importar traducciones
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';

const resources = {
  en: {
    translation: enTranslations
  },
  es: {
    translation: esTranslations
  }
};

i18n
  // Detectar idioma del usuario
  .use(LanguageDetector)
  // Integrar con React
  .use(initReactI18next)
  // Inicializar i18next
  .init({
    resources,
    fallbackLng: 'es', // Idioma por defecto (español para Chile)
    debug: false, // Sin logs por seguridad
    
    // Configuración de detección
    detection: {
      // Orden de detección: localStorage > navigator language > fallback
      order: ['localStorage', 'navigator', 'htmlTag'],
      // Donde persistir la selección del usuario
      caches: ['localStorage'],
      // Key para localStorage
      lookupLocalStorage: 'cuerda-language',
    },

    interpolation: {
      escapeValue: false, // React ya escapa por defecto
    },

    // Configuración de carga
    load: 'languageOnly', // Solo 'en' no 'en-US'
    
    // Idiomas soportados
    supportedLngs: ['es', 'en'],
    
    // No cargar namespace por defecto
    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n; 